interface DonutSlice {
	color: string;
	value: number;
}

interface AdminDonutProps {
	slices: DonutSlice[];
	total: number;
	size?: number;
}

export function AdminDonut({ slices, total, size = 130 }: AdminDonutProps) {
	const r = size / 2 - 12;
	const cx = size / 2;
	const cy = size / 2;
	let acc = 0;

	const hasData = total > 0;

	return (
		<svg viewBox={`0 0 ${size} ${size}`} style={{ width: size, height: size }}>
			{!hasData ? (
				<circle
					cx={cx}
					cy={cy}
					r={r}
					fill="none"
					stroke="var(--a-border, #E2E8F0)"
					strokeWidth="14"
				/>
			) : (
				slices.map((s, i) => {
					const angle = (s.value / total) * 360;
					const start = acc;
					const end = acc + angle;
					acc = end;
					const sx = cx + r * Math.cos(((start - 90) * Math.PI) / 180);
					const sy = cy + r * Math.sin(((start - 90) * Math.PI) / 180);
					const ex = cx + r * Math.cos(((end - 90) * Math.PI) / 180);
					const ey = cy + r * Math.sin(((end - 90) * Math.PI) / 180);
					const large = angle > 180 ? 1 : 0;
					return (
						<path
							key={i}
							d={`M ${sx} ${sy} A ${r} ${r} 0 ${large} 1 ${ex} ${ey}`}
							fill="none"
							stroke={s.color}
							strokeWidth="14"
						/>
					);
				})
			)}
			<text
				x={cx}
				y={cy - 2}
				textAnchor="middle"
				fontSize="20"
				fontWeight="900"
				fontFamily="var(--a-font-display)"
				fill="var(--a-ink)"
			>
				{hasData ? total.toLocaleString("fr-FR").replace(/,/g, " ") : "0"}
			</text>
			<text
				x={cx}
				y={cy + 14}
				textAnchor="middle"
				fontSize="9"
				fill="var(--a-ink-mute)"
				letterSpacing="0.1em"
			>
				TOTAL
			</text>
		</svg>
	);
}

